import { IppicaScommesseEsitoTipoBoxMinMaxProps } from '../ippicaScommesseEsitoTipoBox';
import { breakpoint } from 'utility/constant';
import { convertDecimalQuota } from 'features/ippica/functions';
import { selectQuotaIppica } from 'features/ippica/selectors';
import styles from './IppicaScommesseEsitoTipoBoxChiuso.module.scss';
import { useState } from 'react';
import { useTypedSelector } from 'lib/centralStore';
import useWindowSize, { enComparer } from 'hooks/useWindowSize';

export type IppicaScommesseEsitoTipoBoxChiusoProps = {
  label?: string;
  isSmall?: boolean;
  keyQuota: string;
  keyCavallo: string;
  containerClassName?: string;
};

export const IppicaScommesseEsitoTipoBoxChiuso = ({
  label,
  keyQuota,
  isSmall,
  keyCavallo,
  containerClassName,
}: IppicaScommesseEsitoTipoBoxChiusoProps) => {
  const selectedQuota = useTypedSelector(selectQuotaIppica(keyCavallo, keyQuota));
  // const currentTypeScommessa = useTypedSelector(selectCurrentTypeScommessa);
  let quota = selectedQuota?.value !== 100 ? selectedQuota?.value : undefined;
  // if (isQuotaFissa(currentTypeScommessa!)) {
  // } else {
  //   quota = getQuotaValue(false, selectedQuota);
  // }
  return (
    <ScommesseEsitoTipoBoxChiusoUiContainer
      label={label}
      quota={quota}
      isSmall={isSmall}
      containerClassName={containerClassName}
    />
  );
};

export const IppicaScommesseEsitoTipoBoxChiusoMinMax = ({
  label,
  isSmall,
  containerClassName,
  scommessaKey,
  quotaCombinataStatica,
}: IppicaScommesseEsitoTipoBoxMinMaxProps) => {
  return (
    <ScommesseEsitoTipoBoxChiusoUiContainer
      label={label}
      quota={quotaCombinataStatica}
      isSmall={isSmall}
      containerClassName={containerClassName}
    />
  );
};

export type VirtualScommesseEsitoTipoBoxChiusoProps = {
  label?: string;
  quota: string | number;
  isSmall?: boolean;
  containerClassName?: string;
};

export const VirtualScommesseEsitoTipoBoxChiuso = ({
  label,
  quota,
  isSmall,
  containerClassName,
}: VirtualScommesseEsitoTipoBoxChiusoProps) => {
  return (
    <ScommesseEsitoTipoBoxChiusoUiContainer
      label={label}
      quota={quota}
      isSmall={isSmall}
      containerClassName={containerClassName}
    />
  );
};

export type ScommesseEsitoTipoBoxChiusoUiContainerProps = {
  label?: string;
  quota?: number | string;
  isSmall?: boolean;
  containerClassName?: string;
};

export const ScommesseEsitoTipoBoxChiusoUiContainer = ({
  label,
  quota,
  isSmall,
  containerClassName,
}: ScommesseEsitoTipoBoxChiusoUiContainerProps) => {
  const { doCheck } = useWindowSize();
  const [isMobile] = doCheck([{ comparer: enComparer.less, size: breakpoint.lg }]);
  const [isActive, setIsActive] = useState<boolean>(false);

  return (
    <button
      type="button"
      className={`${styles.container} ${isSmall ? styles.small : ''} ${containerClassName ? containerClassName : ''}`}
      onClick={() => {
        setIsActive(!isActive);
      }}
    >
      {isMobile && <span className={styles.label}>{label ? label : ''}</span>}
      <span className={styles.quota}>
        {quota ? (typeof quota === 'number' ? convertDecimalQuota(quota) : quota) : '-'}
      </span>
    </button>
  );
};
